/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */
import React, { ReactNode } from 'react'

import AssetTableCell from './AssetTableCell'
import { formatDate12, isNullOrUndefined } from './utils'

type UmdColProps = {
  value: string | null
  provisionedDate: Date
  installedDate: Date
}

const tooltipForDevice = (provisionedDate: Date, installedDate: Date) => {
  let tooltip = ''
  if (provisionedDate) {
    tooltip = 'Provisioned: ' + formatDate12(provisionedDate)
  }
  if (installedDate) {
    tooltip += '\nInstalled: ' + formatDate12(installedDate)
  }
  return tooltip
}

const UmdCol: React.FC<UmdColProps> = ({ value, provisionedDate, installedDate }) => {
  const displayBlank = isNullOrUndefined(value) || value === ''

  let displayValue: ReactNode = <div className="h-4 w-full flex"></div>
  if (!displayBlank) {
    displayValue = value
  }

  return <AssetTableCell tooltip={tooltipForDevice(provisionedDate, installedDate)}>{displayValue}</AssetTableCell>
}

export default UmdCol
